module.exports = __webpack_public_path__ + "static/media/Shop-By-Vehicle-Icon.96b3637a.svg";